import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Alarm = (function() {

  function GetTopAlarmers(numberOfAlarmers, pastNumberOfDays) {
    if (logComponent('Alarm')) { console.debug('Alarm GetTopAlarmers'); }
    const params = { numberOfAlarmers, pastNumberOfDays };

    return axios.get('api/Alarm/GetTopAlarmers', getConfig(params));
  }

  function GetTopAlarmsByResponseTime(numberOfAlarms, pastNumberOfDays) {
    if (logComponent('Alarm')) { console.debug('Alarm GetTopAlarmsByResponseTime'); }
    const params = { numberOfAlarms, pastNumberOfDays };

    return axios.get('api/Alarm/GetTopAlarmsByResponseTime', getConfig(params));
  }

  function GetAlarmAverage(pastNumberOfDays, monitoredIndividualId, unitId) {
    if (logComponent('Alarm')) { console.debug('Alarm GetAlarmAverage'); }
    let params = { pastNumberOfDays };

    if (unitId != null) params.unitId = unitId;
    if (monitoredIndividualId != null) params.monitoredIndividualId = monitoredIndividualId;

    return axios.get('api/Alarm/GetAlarmAverage', getConfig(params));
  }

  return {
    GetTopAlarmers,
    GetTopAlarmsByResponseTime,
    GetAlarmAverage
  }
})();

export default Alarm;